import { EnvironmentUrls } from 'Roblox';
import assetsExplorerModule from '../assetsExplorerModule';

const assetsConstants = {
  endpoints: {
    getCatalogMetadata: {
      url: `${EnvironmentUrls.catalogApi}/v1/catalog/metadata`,
      retryable: true,
      withCredentials: true
    },
    getAssetToCatalogCategory: {
      url: `${EnvironmentUrls.catalogApi}/v1/asset-to-category`
    },
    getAssetToCatalogSubcategory: {
      url: `${EnvironmentUrls.catalogApi}/v1/asset-to-subcategory`
    }
  },
  types: {
    myGames: 'MyGames',
    otherGames: 'OtherGames',
    privateServers: 'PrivateServers',
    myPrivateServers: 'MyPrivateServers',
    otherPrivateServers: 'OtherPrivateServers',
    place: 'Place',
    places: 'Places',
    badges: 'Badges',
    gamePasses: 'Game Passes',
    avatarAnimations: 'AvatarAnimations',
    badge: 'Badge',
    gamePass: 'GamePass',
    decal: 'Decal',
    model: 'Model',
    audio: 'Audio',
    video: 'Video',
    plugin: 'Plugin',
    animation: 'Animation',
    meshPart: 'MeshPart',
    accessories: 'Accessories'
  },
  assetTypeIds: {
    badge: 21,
    gamePass: 34,
    place: 9,
    bundle: 32 // Use package assetTypeId for bundles
  },
  itemTypes: {
    asset: 'asset',
    badge: 'badge',
    game: 'game',
    gamePass: 'gamePass',
    bundle: 'bundle'
  },
  favorites: 'favorites',
  catalog: 'catalog',
  library: 'library',
  /*
   * This parameter needs to be specified in urls that lead to the catalog page.
   * Currently, the contexts 0 (old catalog view) and 2 can be accessed by changing the url, but 2 is the one we want users to see.
   */
  currentCatalogContext: '2',
  defaultLayoutData: {
    isPremiumIconOnItemTilesEnabled: false,
    isPremiumPriceOnItemTilesEnabled: false
  },
  userTypes: {
    user: 1,
    group: 2
  },
  robloxSystemUserId: 1
};

assetsExplorerModule.constant('assetsConstants', assetsConstants);
export default assetsConstants;
